module.exports = __webpack_public_path__ + "ed61c26223cf944321f7b8c4994e0a34.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/addnote.png
// module id = 283
// module chunks = 0